var module = angular.module('octopusApp.infrastructure');

module.filter('clickifyDocs', function () {
    return function (input) {
        if (!input) {
            return input;
        }

        return input.replace(/(http:\/\/g\.octopushq\.com\/[a-zA-Z0-9]*)/g, '<a href="$1" target="_blank">$1</a>');
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/clickify-docs.js
// module id = 302679921059460
// module chunks = 1